import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 2.1875C11.6637 2.1875 9.37989 2.88029 7.43733 4.17827C5.49478 5.47624 3.98074 7.3211 3.08668 9.47955C2.19262 11.638 1.95869 14.0131 2.41448 16.3045C2.87027 18.5959 3.9953 20.7007 5.64731 22.3527C7.29931 24.0047 9.4041 25.1297 11.6955 25.5855C13.9869 26.0413 16.362 25.8074 18.5205 24.9133C20.6789 24.0193 22.5238 22.5052 23.8217 20.5627C25.1197 18.6201 25.8125 16.3363 25.8125 14C25.809 10.8682 24.5634 7.86566 22.3489 5.65114C20.1343 3.43662 17.1318 2.19097 14 2.1875ZM10.0625 10.0625C9.59838 10.0625 9.15326 10.2469 8.82507 10.5751C8.49688 10.9033 8.31251 11.3484 8.31251 11.8125C8.31251 12.2766 8.49688 12.7217 8.82507 13.0499C9.15326 13.3781 9.59838 13.5625 10.0625 13.5625C10.5266 13.5625 10.9717 13.3781 11.2999 13.0499C11.6281 12.7217 11.8125 12.2766 11.8125 11.8125C11.8125 11.3484 11.6281 10.9033 11.2999 10.5751C10.9717 10.2469 10.5266 10.0625 10.0625 10.0625ZM17.9375 10.0625C17.4734 10.0625 17.0283 10.2469 16.7001 10.5751C16.3719 10.9033 16.1875 11.3484 16.1875 11.8125C16.1875 12.2766 16.3719 12.7217 16.7001 13.0499C17.0283 13.3781 17.4734 13.5625 17.9375 13.5625C18.4016 13.5625 18.8468 13.3781 19.1749 13.0499C19.5031 12.7217 19.6875 12.2766 19.6875 11.8125C19.6875 11.3484 19.5031 10.9033 19.1749 10.5751C18.8468 10.2469 18.4016 10.0625 17.9375 10.0625ZM8.66907 18.0469C9.27671 17.2005 10.0771 16.511 11.0041 16.0353C11.9312 15.5597 12.9581 15.3116 14 15.3116C15.0419 15.3116 16.0689 15.5597 16.9959 16.0353C17.9229 16.511 18.7233 17.2005 19.3309 18.0469C19.5216 18.3299 19.5945 18.676 19.5343 19.0118C19.4741 19.3477 19.2855 19.6469 19.0084 19.846C18.7313 20.0451 18.3876 20.1285 18.0501 20.0785C17.7125 20.0285 17.4078 19.849 17.2003 19.5781C16.8358 19.0696 16.3554 18.6553 15.7989 18.3694C15.2423 18.0836 14.6257 17.9345 14 17.9345C13.3743 17.9345 12.7577 18.0836 12.2012 18.3694C11.6446 18.6553 11.1642 19.0696 10.7997 19.5781C10.5923 19.849 10.2875 20.0285 9.94995 20.0785C9.61243 20.1285 9.2687 20.0451 8.99163 19.846C8.71456 19.6469 8.52592 19.3477 8.46571 19.0118C8.40549 18.676 8.47843 18.3299 8.66907 18.0469Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconFaceSadFilled'

export const IconFaceSadFilled = memo(themed(Icon))
